import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { CourseDetail, CourseGroup } from '../constants/type.constant';
import Store from '../redux/store';
import { DefaultRequest } from '../requests/default.request';
import '../resources/css/set-dish-detail-item.scss';
import foodDefaultImage from '../assets/food.png';
import CloseIcon from '@material-ui/icons/Close';
import { Button, IconButton } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import RemoveCircleOutlinedIcon from '@material-ui/icons/RemoveCircleOutlined';
import AddCircleOutlinedIcon from '@material-ui/icons/AddCircleOutlined';
import orderCartIcon from '../assets/orderCart.png';
import { allergen as AllergenPic, preLoadNginxImage } from '../tools/utils';
import { StateManager } from '../redux/stateManager';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import i18n from '../i18n';
import { FixedCartData } from '../pages/order-cart';
import ServerShoppingCart from '../modules/server-shopping-cart';
import { DetailMessageObject } from '../messenger/type';
const bargainIcon = require('../assets/bargain-icons/QOP-normal-bargain-icon.png');
const allergenFilterIcon = require('../assets/allergen-filter-icon/QOP-normal-allergen-filter-icon.png');

/**
 * @description 购物车套餐
 */

// 加入或移出购物车
enum UPGRADE {
    REMOVE_DISH = -1,
    ADD_DISH = 1,
}
class ShoppingSetDishDetailItem extends React.Component<Props, State> {
    // 货币文本
    currency_name: string = '€'
    constructor(props: Props) {
        super(props)
        this.onScroll = _.debounce(this.onScroll, 50).bind(this) as any
    }
    // 服务地址
    public serverUrl: string = Store.getState().serverUrl;

    public state: State = {
        courseGroup: [],
        dishImg: '',
        failGroups: [],
        checkFlag: false,
        overFlow: false,
        loading: false,
    }

    // *********************
    // Life Cycle Function
    // *********************
    public async UNSAFE_componentWillMount() {
        await this.preloadImage();
        this.currency_name = StateManager.getFromCache('currency_name') || '€';

    }
    async componentDidMount() {
        this.setState({
            loading: true
        }, async() => {
            await this.init();
            this.setState({
                loading: false
            })
        })
    }

    // *********************
    // Default Function
    // *********************
    /**
     * 预加载图片
     * - 1：先加载菜品图片
     *   - 成功就显示本身
     *   - 失败就显示用户默认图片，步骤2
     * - 2：加载用户设置的默认图片
     *   - 成功就显示
     *   - 失败就显示本地默认图片
     */
    async preloadImage() {
        let dishImg = `${this.serverUrl}/menu_pic/${this.props.details?.id}_s.jpg`;
        const newImage = await preLoadNginxImage(dishImg, '/menu_pic', '', true);
        this.setState({
            dishImg: newImage || foodDefaultImage
        })
    }

    async init() {
        const { details } = this.props;
        // 获取套餐组
        const res = await DefaultRequest.getDishCourse();

        // 获取当前套餐的套餐组
        let courseGroup: CourseGroup[] = [];
        // 请求成功
        if (!_.get(res, 'error')) {
            // 获取当前套餐的套餐组
            courseGroup = (res || []).filter((item) => item.menu_item_id === Number(details.originId));
        }
        courseGroup = this.initDish(courseGroup);
        // @ts-ignore
        if (details.setMealGroups) {
            courseGroup.forEach(item => item.course_detail?.forEach((item1) => {
                // @ts-ignore
                details.setMealGroups?.forEach(item2 => item2?.items?.filter((item3) => {
                    if (item1.detail_id === item3.orderDetailId && item1.menu_item_id === Number(item3.inOrderId)) {
                        item1.num = item3.totalNum
                    }
                }))
            }))
        }

        courseGroup.forEach(m => {
            m.course_detail = m.course_detail?.filter((n: any) => n.item_type! === 0 || n.item_type === 3)
        })
        this.setState({
            courseGroup
        })
    }

    /**
     * 初始化菜品，设置规则
     */
    initDish(courseGroup: CourseGroup[]) {
        courseGroup.forEach((courseGroupItem: CourseGroup) => {
            courseGroupItem?.course_detail?.forEach((dish: any) => {
                _.set(dish, 'num', 0);
                // 给菜品添加“属于套餐区域id”
                _.set(dish, 'belong_course_group_id', courseGroupItem.course_group_id);
            })
        })
        return courseGroup
    }


    /**
     * 滚动
     */
    onScroll() {
        let wrapper = document.getElementById('set-dish-item-dialog-content');
        const dom = document.getElementById(`set-dish-name`);
        if (wrapper && dom) {
            const overFlow = wrapper?.scrollTop > dom?.offsetTop;
            const stateOverFlow = this.state.overFlow;
            if (stateOverFlow !== overFlow) {
                this.setState({ overFlow })
            }
        }
    }

    /**
     * 点击菜品
     */
    changeDishQuantity(courseGroup: any, item: any, type: UPGRADE) {
        // 该区域已选择菜品的数量
        let totalNum = courseGroup?.course_detail?.reduce((p: any, c: any) => p + _.get(c, 'num', 0), 0) || 0;
        let num = item.num || 0;
        // if (item.bargain_stype === 2 && typeof(item.bargain_num_cur) === 'number' && type === 1) {
        //     if (item?.bargain_num_cur < Number(item.num) || item?.bargain_num_cur <= 0) {
        //         this.props.onHandleMessageBar({
        //             message: 'order_cart_page_text_dish_is_sold_out',
        //             level: 'Warning'
        //         })
        //         return;
        //     }
        // }
        if (type === 1) {
            num++;
            totalNum++;
        } else if (type === -1) {
            num--;
            totalNum--;
        }
        // is_must: 1: 必选区域; 0: 非必选区域

        if (totalNum > (courseGroup.choose_num || 0)) {
            return
        }

        _.set(item, 'num', num);
        if (this.state.checkFlag) {
            const failGroups = this.checkRule();
            this.setState({ failGroups })
        }
        this.setState({})
    }
    /**
     * 获取总价格
     * 套餐本身价格 + 里面菜品的价格
     */
    getTotalPrice() {
        const { price } = this.props.details;
        const { courseGroup } = this.state;
        // let totalPrice = price_1 || 0;
        let totalPrice = price || 0;
        courseGroup.forEach((item) => {
            totalPrice += item?.course_detail?.reduce((p: number, c: any) => p + _.get(c, 'price', 0) * _.get(c, 'num', 0), 0) || 0;
        })
        return totalPrice.toFixed(2)
    }

    /**
     * 校验规则
     */
    checkRule() {
        const courseGroup = _.cloneDeep(this.state.courseGroup);
        const failGroups: CourseGroup[] = [];
        courseGroup.forEach((item) => {
            const maximumNum = item.is_must === 1 ? (item.is_full_select ? (item.choose_num || 1) : 999) : (item.choose_num || 1);
            // 必选是至少选择一个
            // - 如果开启必选满，则至少选满choose_num
            const minimumNum = item.is_must === 1 ? (item.is_full_select ? (item.choose_num || 1) : 1)
                : 0;
            const totalNum = item?.course_detail?.reduce((p: number, c: any) => p + _.get(c, 'num', 0), 0) || 0;
            if ((totalNum < minimumNum) || (totalNum > maximumNum)) {
                failGroups.push(item);
            }
        })
        return failGroups
    }


    /**
     * 添加套餐到购物车
     */
    updateCart() {
        const failGroups = this.checkRule();
        if (failGroups.length > 0) {
            this.setState({ failGroups: failGroups, checkFlag: true }, () => {
                const wrapper = document.querySelector(`#set-dish-item-dialog-content`);
                const dom = document.getElementById(`set-dish-item-course-card-${failGroups[0].course_group_id}`);
                if (wrapper && dom) {
                    wrapper.scrollTo({ top: dom.offsetTop - 50, behavior: 'smooth' })
                }
            });
            return
        }

        const details = _.cloneDeep(this.props.details);
        const courseGroup: CourseGroup[] = _.cloneDeep(this.state.courseGroup);
        // 过滤数量为0的菜品
        const filterCourseGroups: CourseGroup[] = courseGroup.map((n: CourseGroup) => {
            if (n.course_detail) {
                const fzArr = n.course_detail.filter(i => i.num && i.num > 0)
                n.course_detail = fzArr;
            }
            return n
        })
        this.changeMenuQuantity({ ...details, setMealGroups: filterCourseGroups as any }, UPGRADE.ADD_DISH);
        this.props.updateLocalState({ setDishItemVisible: false });
    }

    changeMenuQuantity = async (item: FixedCartData, type: UPGRADE) => {
        ServerShoppingCart.updateServerCart({
            dish: item as any,
            mathSymbol: type === 1 ? 0 : 1,
            action: { type: 1, state: 1 },

        })

    }

    // *********************
    // View
    // *********************

    render() {
        const { details, menuItemType } = this.props;
        const { courseGroup, failGroups, overFlow, loading } = this.state;

        return (
            <div className='set-dish-item-dialog-bg'>
                <div className='set-dish-item-dialog' >
                    <div className='set-dish-item-dialog-content'
                        id='set-dish-item-dialog-content'
                        onScroll={() => {
                            this.onScroll();
                        }}
                    >
                        {/* 头部 */}
                        <div className='title-bar  ' style={{ opacity: overFlow ? 1 : 0 }} >
                            <div className='title-text'>{menuItemType ? details.name : details.name2}</div>
                            <div className='title-bar-close-icon' onClick={() => this.props.updateLocalState({ setDishItemVisible: false })}>
                                <CloseIcon style={{ fontSize: 14 }}></CloseIcon>
                            </div>
                        </div>
                        <div className='close-icon ' style={{ opacity: overFlow ? 0 : 1 }} onClick={() => this.props.updateLocalState({ setDishItemVisible: false })}>
                            <CloseIcon style={{ fontSize: 14 }}></CloseIcon>
                        </div>
                        {/* 图片 */}
                        {/* ${this.state.dishImg ? 'animate-fadeIn' : 'MuiSkeleton-wave '} */}
                        <div className={`dish-img ${this.state.dishImg ? 'animate-fadeIn' : 'MuiSkeleton-wave '}`}
                            style={{ backgroundImage: `url(${this.state.dishImg})` }}
                        >
                            <div className='setMenu-icon'>{i18n.t('menu_page_text_setMenu')}</div>
                        </div>
                        {/* 套餐名称 */}
                        <div className='set-dish-name' id={'set-dish-name'}>{menuItemType ? details.name : details.name2}</div>
                        {/* 套餐介绍 */}
                        {/* <div className='set-dish-name-ext'>{details.ext_dish_info} {details.item_description}</div> */}
                        {/* '选择产品'文本 */}
                        <div className='choose-a-product-text'>{i18n.t('menu_page_text_choose_the_products')}</div>
                        {/* 菜品组以及菜品 */}
                        <div className='course-group-list'>
                            {courseGroup?.map((item, index) => {
                                const isfail = failGroups.find((iitem) => iitem.course_group_id === Number(item.course_group_id))

                                return (
                                    <SetDishItemCourseCard
                                        key={index}
                                        data={item}
                                        changeDishQuantity={(CourseDetail: CourseDetail, type: number) => {
                                            this.changeDishQuantity(item, CourseDetail, type)
                                        }}
                                        isfail={!!isfail}
                                        currency_name={this.currency_name}
                                        menuItemType={menuItemType}
                                        serverUrl={this.serverUrl}
                                    />
                                )
                            })}
                        </div>
                        {/* 添加购物车 */}
                        <div className={`add-dish-btn ${ loading ? 'add-dish-btn-disabled' : null}`}>
                            <Button
                                fullWidth
                                className={`add-dish-btn-content`}
                                onClick={() => {
                                    this.updateCart()
                                }}
                                disabled={loading}
                            >
                                <div className='order-cart-icon-box'>
                                    <img src={orderCartIcon} alt='购物车' width={'24'} height={'24'} />
                                    <div className="order-cart-icon-box-text">{i18n.t('order_cart_page_text_confirm_modification')}</div>
                                </div>
                                <div className='price-text'>
                                    {`${this.currency_name + this.getTotalPrice()}`}
                                </div>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ShoppingSetDishDetailItem

/**
 * 套餐里的菜品组
 */
function SetDishItemCourseCard(props: {
    data: CourseGroup;
    isfail: boolean;
    changeDishQuantity: (item: CourseDetail, type: number) => void;
    currency_name: string;
    menuItemType: boolean;
    serverUrl: string;
}) {
    const { data, changeDishQuantity, currency_name, isfail, menuItemType, serverUrl } = props;
    /**
     * 套餐区域菜品的最多点菜数量
     * 如果是必选区域,那么该区域的最大点菜数量就是该区域下的菜品总数
     * 如果是非必选区域，那么最大点菜数量就是choose_num
     * is_must: 1: 必选区域; 0: 非必选区域
     */
    const maximumNum = data.is_must === 1 ? (data.is_full_select ? (data.choose_num || 1) : 999) : (data.choose_num || 1);
    // const minimumNum = data.is_must === 1 ? 1 : 0;
    // 该区域已选择菜品的数量
    const totalNum = data?.course_detail?.reduce((p: number, c: any) => p + _.get(c, 'num', 0), 0);
    // 已选满
    const isFull = totalNum === data.choose_num;
    return (
        <div className='set-dish-item-course-card' id={`set-dish-item-course-card-${data.course_group_id}`}>
            {/* 套餐区域名称 */}
            <div className='name-and-qiantity-box'>
                <div className='course-group-name'>{data.course_group_name}</div>
                {isfail
                    ? <div className='quantity-info-fail'>
                        <div className='check-icon'>
                            <ErrorOutlineIcon />
                        </div>
                        <div>{(data.is_must === 1 && data.is_full_select !== 1) ? i18n.t('menu_page_text_set_menu_required') : `${totalNum}/${maximumNum}`}</div>
                    </div>
                    : <div className='quantity-info'>
                        {totalNum ?
                            <div className='check-icon'>
                                <CheckCircleOutlineIcon />
                            </div>
                            : null
                        }
                        <div>{`${totalNum}/${data.choose_num}`}</div>
                    </div>
                }
            </div>
            {/* 套餐下的菜品 */}
            <div className='course-dish-list'>
                {
                    (data.course_detail || [])?.map((item: CourseDetail, index: number) => {
                        let quantity = item.num || 0;
                        // 过敏原
                        const allergen = (_.get(item, 'allergen') ?? '').split('*');
                        return (
                            <SetDishItemCard
                                serverUrl={serverUrl}
                                index={index}
                                item={item}
                                isFull={isFull}
                                menuItemType={menuItemType}
                                allergen={allergen}
                                changeDishQuantity={changeDishQuantity}
                                currency_name={currency_name}
                                quantity={quantity}
                            />
                        )
                    })
                }
            </div>
        </div>
    )
}

/**
 * 菜品组里的菜品
 */
function SetDishItemCard(props: {
    serverUrl: string;
    index: number;
    item: any;
    isFull: boolean;
    menuItemType: boolean;
    allergen: any;
    changeDishQuantity: (item: CourseDetail, type: number) => void;
    currency_name: string;
    quantity: number;
}) {
    const { serverUrl, index, item, isFull, menuItemType, allergen, changeDishQuantity, currency_name, quantity } = props;

    const [dishItemImg, setDishItemImg] = useState('');

    useEffect(() => {
        preloadCourseDishImage();
    }, [])

    const preloadCourseDishImage = async () => {
        let dishImg = `${serverUrl}/menu_pic/${item.menu_item_id}_s.jpg`;
        const newImage = await preLoadNginxImage(dishImg, '/menu_pic', '', true);
        setDishItemImg(newImage || foodDefaultImage)
    }
    // 过敏原 & 菜品标识过滤器标识
    const filterFlag: boolean = ServerShoppingCart.getAllergensAndIngredentsFilterFlag({
        ...item,
        allergen: allergen,
    });
    // 是否为沽清菜品
    // const isBargainDish = [1, 3].includes(Number(item.bargain_stype)) || (Number(item.bargain_stype) === 2 && Number(item.bargain_num_cur) <= item.quantity);
    const isBargainDish = [1, 2, 3].includes(Number(item.bargain_stype));
    // 是否为数量沽清菜品
    // const isNumBargainDish = (Number(item.bargain_stype) === 2 && typeof(item.bargain_num_cur) === 'number');

    return <>
        <div className='course-dish-item'>
            {/* 沽清菜品禁用样式 */}
            {
                (isBargainDish || filterFlag) ?
                    <div className='bargainStype'>
                        {
                            isBargainDish ? 
                                <div className='mask-icon-box'>
                                    {/* <RoomServiceIcon />
                                    <CloseIcon className=' bargain-icon' /> */}
                                    <img src={bargainIcon} />
                                </div>
                                :
                                null
                        }
                        {filterFlag && <div className='mask-icon-box'><img src={allergenFilterIcon} style={{ width: 40, height: 40 }} /></div>}
                    </div>
                    :
                    null
            }
            {/* 数量沽清标识 */}
            {/* {isNumBargainDish ? 
                <div className='set-bargain-icon-box'>
                    {
                        item.quantity > 0 ?
                        <div className='bargain-badge-box'>
                            <div className={`text ${item.quantity > 0 ? 'active' : 'not-active'}`}>
                            {`${item.num}`}
                            </div>
                            <div className={`text ${item.quantity > 0 ? 'active_3' : ''}`}>
                                {`/${item.bargain_num_cur}`}
                            </div>                                                                                                                                                                          
                        </div>
                        :
                        // todo 国际化
                        <span>{i18n.t('order_cart_page_text_sold_out')}</span>
                    }
                </div>
                :
                null                            
            } */}
            <div className={`coures-dish-img ${dishItemImg ? 'animate-fadeIn' : 'MuiSkeleton-wave '}`}
                style={{ backgroundImage: `url(${dishItemImg})` }}
            >
            </div>
            <div key={index} className={`content  ${isFull ? 'course-dish-list-dish-disabled' : ''}`} >
                <div className='dish-info-box'>
                    <div className='dish-name'>
                        {menuItemType ? item?.item_name1 : item?.item_name2}
                    </div>
                    <div className="dish-detail-allergen-box">
                        {allergen.map((allergenItem: string, allergenIndex: number) => {
                            let pic = AllergenPic(allergenItem);
                            if (pic) {
                                return (
                                    <img className='allergen-pic' src={pic} alt={allergenItem} key={allergenIndex} />
                                )
                            }
                            else {
                                return <></>
                            }
                        })}
                    </div>
                    <div className='dish-description' >
                        {item?.ext_dish_info} {item?.item_description}
                    </div>
                </div>
                <div className='pricebox'>
                    <p className='priceboxprice'>
                        {item?.price ? <span>{'+'}{currency_name}{item.price?.toFixed(2)}</span> : null}
                    </p>
                    < div className='priceNumber'>
                        {
                            <IconButton
                                onClick={(evt) => {
                                    evt.stopPropagation();
                                    changeDishQuantity(item, UPGRADE.REMOVE_DISH)
                                }}
                                disabled={!quantity}
                            >
                                <RemoveCircleOutlinedIcon
                                    className={`AiFillPlusCircle animate-fadeIn ${quantity ? 'AiFillMinusCircle' : 'disabled-plus-icon'}`}
                                />
                            </IconButton>
                        }
                        <p className={`number animate-fadeIn ${quantity ? 'number' : 'is_no_number'}`}>
                            {quantity}
                        </p>
                        {
                            <IconButton
                                onClick={(evt) => {
                                    evt.stopPropagation();
                                    changeDishQuantity(item, UPGRADE.ADD_DISH)
                                }}
                                disabled={isFull}
                            >
                                <AddCircleOutlinedIcon className={`AiFillPlusCircle ${quantity ? 'plus-icon-has_number' : ''} ${isFull ? 'disabled-plus-icon' : ''}`} />
                            </IconButton>
                        }
                    </div>
                </div>
            </div>
        </div>
    </>
}

// *********************
// State & Props
// *********************

type State = {
    // 套餐组
    courseGroup: CourseGroup[];
    // 菜品图片
    dishImg: string;
    // 不符合条件的组
    failGroups: CourseGroup[];
    // 检查规则
    checkFlag: boolean;
    // 超出
    overFlow: boolean;
    loading: boolean;
}

type Props = {
    // 详情
    details: FixedCartData;
    // 菜名显示
    menuItemType: boolean;
    updateLocalState: (val: any) => void
    customers: string
    turnRound: null | string
    customerArr: string[]
    roundArr: string[]
    onHandleMessageBar: (dmo: DetailMessageObject & { isIgnoreTransI18N?: boolean }) => void;
}
